// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".error[data-v-c050198c]{background-position:50%;background-size:cover;color:#1a1a1a;display:flex;flex-direction:column;height:100vh;justify-content:flex-end;text-align:center;width:100%}@media(max-width:768px){.error[data-v-c050198c]{background-size:20%}}.error a[data-v-c050198c],.error[data-v-c050198c]:visited{color:#60f;margin:1rem 0 3rem}.error a[data-v-c050198c]:hover{color:#555}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
